import { formatEditorValueFromJsObj } from 'modules/aceEditor/utils';
import { useQueryParamContext } from '../context/QueryParamContext';
import { useTemplateStateContext } from '../integrations/context/TemplateStateContextProvider';
import { useQueryTemplateJsonTestData } from './useQueryTemplateJsonTestData';

export const useGetTemplateUserJsonTestData = () => {
  const { templateId: queryTemplateId, locale: queryLocale } = useQueryParamContext();
  const { templateId: stateTemplateId, locale: stateLocale } = useTemplateStateContext();

  // We currently are storing locale in two places depending on where the user is editing the template
  const locale = queryLocale || stateLocale;
  const templateId = queryTemplateId || stateTemplateId;

  const result = useQueryTemplateJsonTestData({
    skip: true, // We want to trigger the query manually
    fetchPolicy: 'no-cache',
  });

  /**
   * Returns passed user data or fetches it from the server when invalid or empty json is passed
   * @param userData - User data to be used
   * @param isUserDataDirty - whether the user data has been modified
   */
  const getTemplateUserJsonTestData = async (userData: string = '{}', isUserDataDirty = false) => {
    let currUserData = userData;

    if (!userData || (!isUserDataDirty && userData.replace(/ /g, '') === '{}')) {
      const data = await result.refetch({
        id: templateId,
        locale: locale ? { name: locale } : undefined, // use default locale (i.e. `undefined`) if none is currently set
      });
      const savedUserTestData = data?.data?.templateAndSingleContent?.jsonTestData?.userJson;

      currUserData = formatEditorValueFromJsObj(savedUserTestData);

      return currUserData;
    }

    return currUserData;
  };

  return { ...result, getTemplateUserJsonTestData };
};
